import {
  InputField,
  UploadImageField,
  LoaderButton
} from 'components/molecules'
import { WEB_URL_CONSTANTS } from 'constants/web-url-constants'
import RowButton from 'components/atoms/row-button'
import SellerSelectSearchField from 'domains/seller/molecules/select-search-field'
import { Form, Formik } from 'formik'
import PropTypes from 'prop-types'
import React from 'react'
import { Col, Row } from 'reactstrap'

const propTypes = {
  featured_seller: PropTypes.shape({
    seller: PropTypes.shape({
      id       : PropTypes.number,
      name     : PropTypes.string,
      username : PropTypes.string,
      url_key  : PropTypes.string
    }),
    seller_id                           : PropTypes.number,
    bio                                 : PropTypes.string,
    occupation                          : PropTypes.string,
    hero_image_url                      : PropTypes.string,
    hero_video_url                      : PropTypes.string,
    favourite_brand_thumbnail_image_url : PropTypes.string,
    inspired_look_thumbnail_image_url   : PropTypes.string
  }),
  buttonText                           : PropTypes.string,
  heroImage                            : PropTypes.object,
  sliderImage                          : PropTypes.object,
  favouriteBrandThumbnailImage         : PropTypes.object,
  inspiredLookThumbnailImage           : PropTypes.object,
  url                                  : PropTypes.string,
  isEditAction                         : PropTypes.bool,
  setHeroImage                         : PropTypes.func,
  setSliderImage                       : PropTypes.func,
  setFavouriteBrandThumbnailImage      : PropTypes.func,
  setInspiredLookThumbnailImage        : PropTypes.func,
  handleRedirectEditFavouriteBrandPage : PropTypes.func,
  handleRedirectEditInspiredLookPage   : PropTypes.func,
  validationSchema                     : PropTypes.object,
  handleSubmitForm                     : PropTypes.func.isRequired
}

const defaultProps = {
  featured_seller: {
    seller: {
      id       : 0,
      name     : '',
      username : '',
      url_key  : ''
    },
    seller_id                           : '',
    bio                                 : '',
    occupation                          : '',
    hero_image_url                      : '',
    hero_video_url                      : '',
    favourite_brand_thumbnail_image_url : '',
    inspired_look_thumbnail_image_url   : ''
  },
  buttonText                           : '',
  heroImage                            : new Blob(),
  sliderImage                          : new Blob(),
  favouriteBrandThumbnailImage         : new Blob(),
  inspiredLookThumbnailImage           : new Blob(),
  url                                  : '',
  isEditAction                         : false,
  setHeroImage                         : () => {},
  setSliderImage                       : () => {},
  setFavouriteBrandThumbnailImage      : () => {},
  setInspiredLookThumbnailImage        : () => {},
  handleRedirectEditFavouriteBrandPage : () => {},
  handleRedirectEditInspiredLookPage   : () => {},
  validationSchema                     : {},
  handleSubmitForm                     : () => {}
}

/**
 * Form to create and edit CMS Featured Seller
 */

const CmsFeaturedSellerForm = ({
  featured_seller,
  url,
  isEditAction,
  buttonText,
  heroImage,
  sliderImage,
  favouriteBrandThumbnailImage,
  inspiredLookThumbnailImage,
  setHeroImage,
  setSliderImage,
  setFavouriteBrandThumbnailImage,
  setInspiredLookThumbnailImage,
  handleRedirectEditFavouriteBrandPage,
  handleRedirectEditInspiredLookPage,
  validationSchema,
  handleSubmitForm
}) =>  (
  <Formik
    enableReinitialize={ true }
    initialValues={ featured_seller }
    validationSchema={ validationSchema }
    onSubmit={ handleSubmitForm }
  >
    {
      (formikBag) => (
        <>
          {
            formikBag.values.seller.url_key?
              <h3>
                { 'Go to Featured Seller page ' }
                <a
                  className='text-primary'
                  href={ `${WEB_URL_CONSTANTS.HOMEPAGE}/featured-sellers/${formikBag.values.seller.url_key}` }
                  target='_blank' rel='noopener noreferrer'
                >
                  { 'here' }
                </a>
              </h3>
              :
              null
          }

          <Form>
            <SellerSelectSearchField
              name={ isEditAction ? 'seller.id' : 'seller_id' }
              label='Seller'
              disabled={ isEditAction }
              required={ true }
            />

            <InputField
              type='text'
              name='occupation'
              label='Occupation'
              placeholder='Actress / Singer'
              required={ true }
            />
            <InputField
              type='textarea'
              rows='5'
              name='bio'
              label='Bio'
              placeholder=''
              required={ true }
            />
            <InputField
              type='text'
              name='hero_video_url'
              label='Hero Video Url'
              placeholder='https://www.youtube.com/embed/oT1ruIpX4nE'
              required={ false }
            />
            <UploadImageField
              id='output-hero-image'
              label='Cover Image'
              image={ heroImage }
              required={ true }
              initialImageSrc={ formikBag.values.hero_image_url }
              setValue={ (input) => {
                setHeroImage(input)
              } }
            />
            <UploadImageField
              id='output-slider-image'
              label='Thumbnail/ Slider Image'
              image={ sliderImage }
              required={ true }
              initialImageSrc={ formikBag.values.slider_image_url }
              setValue={ (input) => {
                setSliderImage(input)
              } }
            />
            <Row >
              <Col lg='6'>
                <UploadImageField
                  id='output-favourite-brand-thumbnail-image'
                  label='Favourite Brand Thumbnail Image'
                  image={ favouriteBrandThumbnailImage }
                  initialImageSrc={ formikBag.values.favourite_brand_thumbnail_image_url }
                  setValue={ (input) => {
                    setFavouriteBrandThumbnailImage(input)
                  } }
                />
              </Col>
              {
                isEditAction && featured_seller.favourite_brand_thumbnail_image_url ?
                  <Col lg='6'>
                    <RowButton
                      className='float-right'
                      color="primary"
                      onClick={ () => handleRedirectEditFavouriteBrandPage(url) }
                      text="Edit Page"
                    />
                  </Col>
                  : null
              }

            </Row>

            <Row >
              <Col lg='6'>
                <UploadImageField
                  id='output-inspired-look-thumbnail-image'
                  label='Inspired Look Thumbnail Image'
                  image={ inspiredLookThumbnailImage }
                  initialImageSrc={ formikBag.values.inspired_look_thumbnail_image_url }
                  setValue={ (input) => {
                    setInspiredLookThumbnailImage(input)
                  } }
                />
              </Col>
              {
                isEditAction && featured_seller.inspired_look_thumbnail_image_url ?
                  <Col lg='6'>
                    <RowButton
                      className='float-right'
                      color="primary"
                      onClick={ () => handleRedirectEditInspiredLookPage(url) }
                      text="Edit Page"
                    />
                  </Col>
                  : null
              }
            </Row>

            <Row >
              <Col>
                <LoaderButton
                  className='float-right'
                  color='success'
                  isLoading={ formikBag.isSubmitting }
                  onClick={ formikBag.submitForm }
                  text={ buttonText }
                />
              </Col>
            </Row>

          </Form>
        </>
      )
    }
  </Formik>
)

CmsFeaturedSellerForm.propTypes    = propTypes
CmsFeaturedSellerForm.defaultProps = defaultProps

export default CmsFeaturedSellerForm
